import Amplify from "aws-amplify";
export default function iniciarConfiguracionAPI() {
  let headers = {
    "Content-Type": "application/json", //'x-api-key': process.env.REACT_APP_X_API_KEY
  };
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: process.env.REACT_APP_REGION,
      identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
      userPoolId: process.env.REACT_APP_USERPOOLID,
      userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
      oauth: {
        domain: process.env.REACT_APP_USER_POOL_DOMAIN_NAME,
        redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
        redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
        responseType: process.env.REACT_APP_OAUTH_RESPONSE_TYPE,
        scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
      },
    },
    API: {
      endpoints: [
        {
          name: process.env.REACT_APP_ENDPOINT_NAME,
          endpoint: process.env.REACT_APP_URL_API,
          region: process.env.REACT_APP_REGION,
          custom_header: async () => {
            return headers;
          },
        }
      ],
    }
  });
}
export  function iniciarConfiguracionAPINoAuth() {
  let headers = {
    "Content-Type": "application/json", //'x-api-key': process.env.REACT_APP_X_API_KEY
  };
  Amplify.configure({
    Auth: {
      mandatorySignIn: false,
      region: process.env.REACT_APP_REGION,
      identityPoolId: process.env.REACT_APP_IDENTITYPOOLID_NOAUTH      
    },
    API: {
      endpoints: [
        {
          name: process.env.REACT_APP_ENDPOINT_NAME,
          endpoint: process.env.REACT_APP_URL_API,
          region: process.env.REACT_APP_REGION,
          custom_header: async () => {
            return headers;
          },
        }
      ]
    }
  });
}
